<template>
  <div class="forms">
    <Submitted 
      v-if="submitted" 
      @resetEnquiry="resetEnquiry" 
      :submissionId="submissionId"
    />    
    <TheDisasterRecoveryForm v-else @submitEnquiry="submitEnquiry" />
    <TheDisasterRecoveryPrivacyNotice />
  </div>
</template>

<script>
import TheDisasterRecoveryPrivacyNotice from '@/components/disasterrecovery/TheDisasterRecoveryPrivacyNotice.vue'
import TheDisasterRecoveryForm from '@/components/disasterrecovery/TheDisasterRecoveryForm.vue'
import Submitted from '@/components/disasterrecovery/Submitted.vue'

export default {
  name: 'TheDisasterRecovery',
  components: {
    TheDisasterRecoveryForm,
    Submitted,
    TheDisasterRecoveryPrivacyNotice
  },
  data: function() {
    return {
      submitted: false,
      submissionId: ''
    }
  },
  methods: {
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      this.submissionId = result.submissionId;
      scroll(0, 0);
    },
    resetEnquiry: function() {
      this.submitted = false;
      scroll(0, 0); 
    }
  }
}
</script>

